import { z } from 'zod';

import { FileRevisionSchema } from './file-revisions';
import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { commaDelimitedList } from './utils';

/**
 * A text content is a piece of text extracted from a file revision
 *
 * Note that content is omitted as a field here since the service provides an async method to fetch instead
 */
export const TextContentSchema = z.object({
  textContentId: z.string().nanoid(),
  fileRevisionId: FileRevisionSchema.shape.fileRevisionId,
  createdAt: z.coerce.date(),
});

export type TextContent = z.infer<typeof TextContentSchema>;

export const TextContentsSchema = z.array(TextContentSchema);

export type TextContents = z.infer<typeof TextContentsSchema>;

export const TextContentFiltersSchema = z
  .object({
    textContentIds: commaDelimitedList(
      TextContentSchema.shape.textContentId.array(),
    ).optional(),
    fileRevisionIds: commaDelimitedList(
      FileRevisionSchema.shape.fileRevisionId.array(),
    ).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type TextContentFilters = z.infer<typeof TextContentFiltersSchema>;

export const TextContentContentFormatSchema = z.enum(['markdown']);

export type TextContentContentFormat = z.infer<
  typeof TextContentContentFormatSchema
>;

export const TextContentContentSchema = z.discriminatedUnion('format', [
  z.object({
    format: z.literal('markdown'),
    content: z.string(),
  }),
]);

export type TextContentContent = z.infer<typeof TextContentContentSchema>;
